import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Query, Mutation } from 'react-apollo';
import Select from 'react-select';

import { AuthContext } from '../../../context';

import mutations from '../../../graphql/mutations';
import queries from '../../../graphql/queries';

import style from './index.module.scss';

const {
  questionMutations: { ASK_QUESTION },
} = mutations;
const {
  topicQueries: { TOPICS },
} = queries;

class NewQuestionForm extends Component {
  static contextType = AuthContext;

  state = {
    title: '',
    description: '',
    topic: '',
    topicList: [],
    isAuthorAnonymous: false,
  };

  onSelect = topic => {
    this.setState({
      topic,
      topicList: [...topic],
    });
  };

  onChange = e =>
    this.setState({
      [e.target.name]: e.target.value,
    });

  onCheck = e =>
    this.setState({
      isAuthorAnonymous: !this.state.isAuthorAnonymous,
    });

  onSubmitQuestion = (e, askQuestion) => {
    e.preventDefault();

    const { title, description, topicList, isAuthorAnonymous } = this.state;

    const { closeModal } = this.props;

    const formattedTopics = topicList.map(topic => topic.value);

    if (title && topicList.length !== 0) {
      askQuestion({
        variables: {
          input: {
            title,
            description,
            askedBy: this.context.currentUser.id,
            isAuthorAnonymous,
            topics: formattedTopics,
          },
        },
      });

      this.setState({
        title: '',
        description: '',
        topicList: [],
        isAuthorAnonymous: false,
      });

      closeModal();
    }
  };

  render() {
    const {
      title,
      description,
      topic,
      topicList,
      isAuthorAnonymous,
    } = this.state;
    const { closeModal } = this.props;

    return (
      <div className={`row ${style['row--form']}`}>
        <Mutation mutation={ASK_QUESTION}>
          {askQuestion => (
            <form
              className={style['add-answer']}
              onSubmit={e => this.onSubmitQuestion(e, askQuestion)}
            >
              <div className={`row ${style['row--user']}`}>
                <div className={`col-12 ${style['col--user']}`}>
                  <div className={style['current-user']}>
                    <img
                      className={style['current-user-img']}
                      src={this.context.currentUser.imgUrl || 'https://i.imgur.com/qHpJwKV.jpg'}
                      alt={this.context.currentUser.fullname}
                    />
                    <Link
                      className={`text-muted ${
                        style['current-user-name']
                      }`}
                      to={{
                        pathname: `/account/${this.context.currentUser.fullname}`,
                        state: {
                          userId: this.context.currentUser.id,
                        },
                      }}
                    >
                      {this.context.currentUser.fullname}
                    </Link>
                  </div>
                </div>
              </div>
              <div className={`row ${style['row--topics']}`}>
                <div className={`col-12 ${style['col--topics']}`}>
                  <label className={style.label}>Select topic(s)</label>
                  <Query query={TOPICS}>
                    {({ loading, error, data: { topics } }) => {
                      if (loading) return <div>Loading...</div>;
                      if (error)
                        return <div>{JSON.stringify(error)}</div>;

                      return (
                        <Select
                          name='topic'
                          value={topic}
                          onChange={this.onSelect}
                          isMulti
                          isSearchable={true}
                          valueArray={topicList}
                          options={topics.map(topic => ({
                            label: topic.name,
                            value: topic.name,
                          }))}
                          placeholder='Select topic(s)'
                        />
                      );
                    }}
                  </Query>
                </div>
              </div>
              <div className={`row ${style['row--textarea']}`}>
                <textarea
                  className={`form-control input ${
                    style['input--textarea']
                  } ${style['input--title']}`}
                  rows='2'
                  name='title'
                  value={title}
                  placeholder='Start you question with "With", "What", "How", etc'
                  onChange={this.onChange}
                />
                <label className={style.label}>Optional</label>
                <textarea
                  className={`form-control input ${
                    style['input--textarea']
                  } ${style['input--description']}`}
                  rows='3'
                  name='description'
                  value={description}
                  placeholder='Include description and/or link that gives context'
                  onChange={this.onChange}
                />
              </div>
              <div className={`row ${style['row--actions']}`}>
                <div
                  className={`col-12 ${style['col--actions']} ${
                    style.buttons
                  }`}
                >
                  <button
                    className={`text-muted btn ${style.btn} ${
                      style['btn--cancel']
                    }`}
                    type='click'
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <div className={style.submit}>
                    <div className={style.anonymous}>
                      <input
                        className={style['anonymous-add']}
                        type='checkbox'
                        name='isAuthorAnonymous'
                        checked={isAuthorAnonymous}
                        onChange={this.onCheck}
                      />
                      <label className={style['anonymous-label']}>
                        Add anonymously
                      </label>
                    </div>
                    <button
                      className={`btn ${style.btn} ${
                        style['btn--submit']
                      }`}
                      type='submit'
                    >
                      Add Question
                    </button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Mutation>
      </div>
    );
  }
}

NewQuestionForm.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default NewQuestionForm;
